import React, { useEffect, useState } from "react";
import Button from "@mui/material/Typography";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { changeDateToLocal } from ".";
import AxiosInstance from "service/axiosInstance";

const EditedTxsDetailModal = ({ data, handleCloseDialog }) => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDownloadClick = () => {
    handleCloseDialog(false);
    window.print();
  };

  // Fetch audit logs as fallback when prevTransaction (history) is missing
  useEffect(() => {
    if (!data?.history && data?.id) {
      setLoading(true);
      AxiosInstance({
        method: "GET",
        url: "api/v1/admin/transaction/" + data.id + "/audit-logs",
      })
        .then((res) => {
          setAuditLogs(res?.data?.logs ?? []);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [data]);

  if (!data) {
    return (
      <div className="pt-10">
        <Typography style={{ fontSize: "16px", color: "#1B2559" }}>
          No history data available
        </Typography>
      </div>
    );
  }

  // No prevTransaction — show audit log timeline as fallback
  if (!data.history) {
    if (loading) {
      return (
        <div className="pt-10 flex justify-center">
          <CircularProgress size={24} />
        </div>
      );
    }

    if (auditLogs.length === 0) {
      return (
        <div className="pt-10">
          <Typography style={{ fontSize: "16px", color: "#1B2559" }}>
            No history data available
          </Typography>
        </div>
      );
    }

    return (
      <div className="pt-10">
        <Typography style={{ fontSize: "16px", color: "#1B2559", fontWeight: 700, marginBottom: 12 }}>
          Edit History
        </Typography>
        {auditLogs.map((log, i) => (
          <div key={log.id ?? i} style={{ borderBottom: "1px solid #eee", paddingBottom: 8, marginBottom: 8 }}>
            <Typography style={{ fontSize: "14px", color: "#555" }}>
              Edited by: <strong>{log.editorName || "Unknown"}</strong>
            </Typography>
            <Typography style={{ fontSize: "13px", color: "#888" }}>
              {log.createdAt ? changeDateToLocal(log.createdAt) : ""}
            </Typography>
            <div style={{ marginTop: 4, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
              {log.amount != null && <Typography style={{ fontSize: "13px" }}>Amount: {log.amount}</Typography>}
              {log.type && <Typography style={{ fontSize: "13px" }}>Type: {log.type}</Typography>}
              {log.mode && <Typography style={{ fontSize: "13px" }}>Mode: {log.mode}</Typography>}
              {log.description && <Typography style={{ fontSize: "13px" }}>Description: {log.description}</Typography>}
              {log.interest != null && <Typography style={{ fontSize: "13px" }}>Interest: {log.interest ? "Yes" : "No"}</Typography>}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="pt-10">
      <div className=" bg-white mb-10 flex flex-col gap-2">
        <div className="grid grid-cols-3 gap-x-3">
          <Typography
            className="text-primary font-bold capitalize"
            style={{ fontSize: "16px", color: "#1B2559" }}
          ></Typography>
          <Typography
            className="text-primary font-bold capitalize"
            style={{ fontSize: "16px", color: "#1B2559" }}
          >
            Current
          </Typography>
          <Typography
            className="text-primary font-bold capitalize"
            style={{ fontSize: "16px", color: "#1B2559" }}
          >
            Previous
          </Typography>
        </div>
        <UserKeyValue
          label={"Transaction ID"}
          value={data.id}
          prevValue={data.history.transactionId}
        />
        <UserKeyValue
          label={"Employee ID"}
          value={data.employeeId}
          prevValue={data.employeeId}
        />
        <UserKeyValue
          label={"Entry Timestamp"}
          value={changeDateToLocal(data.createdAt)}
          prevValue={changeDateToLocal(data.history.updatedAt)}
        />
        <UserKeyValue
          label={"Transaction Date"}
          value={changeDateToLocal(data.transactionDate, false)}
          prevValue={changeDateToLocal(data.history.createdAt, false)}
        />
        <UserKeyValue
          label={"Type"}
          value={data.type}
          prevValue={data.history.type}
        />
        <UserKeyValue
          label={"Category"}
          value={data.source}
          prevValue={data.history.source?.name}
        />
        <UserKeyValue
          label={"Sub Category"}
          value={data.subCategory}
          prevValue={data.history.description}
        />
        <UserKeyValue
          label={"Mode of Payment"}
          value={data.mode}
          prevValue={data.history.mode}
        />
        <UserKeyValue
          label={"Amount"}
          value={data.amount}
          prevValue={data.history.amount}
        />
        <UserKeyValue
          label={"Interest"}
          value={data.interest ? "Yes" : "No"}
          prevValue={data.history.interest ? "Yes" : "No"}
        />
      </div>
      <div className="flex items-center mx-auto justify-center gap-5">
        <Button
          variant="standard"
          className="whitespace-nowrap  capitalize font-semibold text-sm px-5 py-2 text-white bg-[#3D3E78] cursor-pointer"
          onClick={() => handleDownloadClick()}
        >
          Download
        </Button>
      </div>
    </div>
  );
};

export default EditedTxsDetailModal;

export function UserKeyValue({ label, value, prevValue }) {
  return (
    <div className="grid grid-cols-3 gap-x-3">
      <Typography
        className="text-primary font-bold capitalize"
        style={{ fontSize: "16px", color: "#1B2559" }}
      >
        {label}
      </Typography>
      <p>{value}</p>
      <p>{prevValue}</p>
    </div>
  );
}
